export const DATE_ONLY_FORMATS = [
  'MMDDYY',
  'MDDYY',
  'MMDYY',
  'MDYY',
  'MM/DD/YY',
  'M/DD/YY',
  'MM/D/YY',
  'M/D/YY',
  'MM-DD-YY',
  'M-DD-YY',
  'MM-D-YY',
  'M-D-YY',
  'MM.DD.YY',
  'M.DD.YY',
  'MM.D.YY',
  'D.M.YY',
  'MMDD',
  'MM/DD',
  'M/DD',
  'MM/D',
  'M/D',
  'MM-DD',
  'M-DD',
  'MM-D',
  'M-D',
  'MMM D',
  'MMM DD',
  'MMM D YY',
  'MMM DD YY',
  'MMM D, YY',
  'MMM DD, YY',
  'MM/DD/YYYY',
  'M/DD/YYYY',
  'MM/D/YYYY',
  'M/D/YYYY',
  'MM-DD-YYYY',
  'M-DD-YYYY',
  'MM-D-YYYY',
  'M-D-YYYY',
  'MM.DD.YYYY',
  'M.DD.YYYYY',
  'MM.D.YYYY',
  'M.D.YYYY',
  'MMDDYYYY',
  'MMM D YYYY',
  'MMM DD YYYY',
  'MMM D, YYYY',
  'MMM DD, YYYY',
];
